import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import withRoot from '../withRoot';
import DiceUtil from '../utils/DiceUtil';
import { IconButton, Typography, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails, ListItem, ListItemText, ListItemSecondaryAction, List, Collapse, Checkbox } from '@material-ui/core';
import CasinoIcon from '@material-ui/icons/Casino';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Switch from '@material-ui/core/Switch';
import Armors from './Armors.json';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

const styles = theme => ({
    root: {
        margin: theme.spacing.unit,
    },
    expansion: {
        width: "300px",
    },
    listText: {
        width: "180px",
    },
});

class ArmorRoller extends Component {
    constructor(props) {
        super(props);

        const typeStatus = {};
        for (let i = 0; i < Armors.types.length; i++) {
            typeStatus[Armors.types[i]] = true;
        }

        this.state = {
            result: null,
            availableTypes: Array(Armors.values.length).fill(true),
            typeStatus: typeStatus,
            isOpen: {},
        };
    }

    handleOpenChange = name => () => {
        const isOpen = Object.assign({}, this.state.isOpen, { [name]: !this.state.isOpen[name] });
        this.setState({
            isOpen: isOpen,
        });
    };

    handleArmorTypeToggle = armorType => () => {
        let typeStatus = this.state.typeStatus[armorType];
        typeStatus = (typeStatus === "indeterminate" || typeStatus === true) ? false : true;

        const availableTypes = this.state.availableTypes.concat();
        for (let i = 0; i < Armors.values.length; i++){
            if (Armors.values[i].type === armorType) {
                availableTypes[i] = typeStatus;
            }
        }

        this.setState({
            availableTypes: availableTypes,
            typeStatus: Object.assign({}, this.state.typeStatus, { [armorType]: typeStatus }),
        });
    };

    handleArmorToggle = index => () => {
        const availableTypes = this.state.availableTypes.concat();
        availableTypes[index] = !availableTypes[index];

        const typeStatus = {};
        for (let i = 0; i < Armors.values.length; i++){
            let armorType = Armors.values[i].type;
            if (armorType in typeStatus) {
                if (typeStatus[armorType] !== availableTypes[i]) {
                    typeStatus[armorType] = "indeterminate";
                }
            }
            else
            {
                typeStatus[armorType] = availableTypes[i];
            }
        }

        this.setState({ 
            availableTypes: availableTypes,
            typeStatus: typeStatus,
         });
    };

    rollArmor() {
        const myArmors = [];
        const armorLength = Armors.values.length;

        for (let i = 0; i < armorLength; i++) {
            if (this.state.availableTypes[i]) {
                myArmors[myArmors.length] = Armors.values[i].name;
            }
        }

        const roll = DiceUtil.dice(myArmors.length) - 1;

        this.setState({ result: myArmors[roll] });
    }

    render() {
        const { classes } = this.props;

        const armorTypeList = Armors.types.map((armorType) => (
            <List key={armorType}>
                <ListItem button onClick={this.handleArmorTypeToggle(armorType)}>
                    {
                        this.state.typeStatus[armorType] === "indeterminate" ?
                            (<Checkbox checked={this.state.typeStatus[armorType]} value={armorType} indeterminate />) :
                            (<Checkbox checked={this.state.typeStatus[armorType]} value={armorType} />)
                    }
                    <ListItemText primary={armorType} />
                    <ListItemSecondaryAction>
                        <IconButton aria-label="Expand" onClick={this.handleOpenChange(armorType)} >
                            {this.state.isOpen[armorType] ? <ExpandLess /> : <ExpandMore />}
                        </IconButton>
                    </ListItemSecondaryAction>
                </ListItem>
                <Collapse in={this.state.isOpen[armorType]}>
                    <List component="div" disablePadding>
                        {Armors.values.map((armor, index) => {
                            return armor.type === armorType ? (
                                <ListItem key={index}>
                                    <ListItemText primary={armor.name} className={classes.listText} />
                                    <ListItemSecondaryAction>
                                        <Switch onChange={this.handleArmorToggle(index)} checked={this.state.availableTypes[index]} />
                                    </ListItemSecondaryAction>
                                </ListItem>
                            ) : null
                        })}
                    </List>
                </Collapse>
            </List>
        ));

        return (
            <div className={classes.root}>
                <ExpansionPanel className={classes.expansion}>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography>Filters</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        <List>
                            {armorTypeList}
                        </List>
                    </ExpansionPanelDetails>
                </ExpansionPanel>

                <Typography>
                    <IconButton color="inherit" aria-label="Roll" onClick={() => this.rollArmor()}>
                        <CasinoIcon />
                    </IconButton>

                    {this.state.result}
                </Typography>
            </div>
        );
    }
}

ArmorRoller.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withRoot("Armor Roller", withStyles(styles)(ArmorRoller));


// WEBPACK FOOTER //
// ./src/item-helpers/ArmorRoller.js